import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { HEIGHT_ITEM, STROKE_PARAM } from '../const';
import { getScreenViewVertical } from '../functions';
import { RootState } from '../store';
import { getExpandedItems } from '../table/functions';
import { ItemType, MappingItemIdIndexType } from '../types';

interface IGantGridRow {}

const GantGridRow: React.FC<IGantGridRow> = () => {
    const currentScrollY = useSelector<RootState, number>((state) => state.gantScroll.currentScrollY);
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);
    const availableHeight = useSelector<RootState, number>((state) => state.gant.availableHeight);
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);
    const { start, end } = getScreenViewVertical(currentScrollY, availableHeight);

    const renderRowLine = useMemo(() => {
        const cells: any[] = [];

        let ind = start + 1;
        const newItems = getExpandedItems(itemsList, mappingItemIdIndex).slice(start, end);

        newItems.forEach(() => {
            cells.push(
                <g key={'line' + ind} style={{ pointerEvents: 'none', mixBlendMode: 'normal' }}>
                    <g></g>
                    <line x1={0} y1={ind * HEIGHT_ITEM} x2="100%" y2={ind * HEIGHT_ITEM} {...STROKE_PARAM} />
                </g>,
            );
            ind++;
        });

        return <g>{cells}</g>;
    }, [itemsList, start, end]);

    return <>{renderRowLine}</>;
};

export default GantGridRow;
